'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var block = require('multiformats/block');

var base58 = require('multiformats/bases/base58');

var writer = require('@ipld/car/writer');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var debug = require('debug');

var raw = require('multiformats/codecs/raw');

var json = require('multiformats/codecs/json');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var raw__namespace = /*#__PURE__*/_interopNamespace(raw);

var json__namespace = /*#__PURE__*/_interopNamespace(json);

var log = debug__default["default"]('ipfs:components:dag:import');
var NO_LINKS_CODECS = [raw__namespace.code, json__namespace.code];

function createExport(_ref) {
  var repo = _ref.repo,
      preload = _ref.preload,
      codecs = _ref.codecs;

  function dagExport(_x) {
    return _dagExport.apply(this, arguments);
  }

  function _dagExport() {
    _dagExport = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(root) {
      var options,
          cid$1,
          _yield$_awaitAsyncGen,
          writer$1,
          out,
          err,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          chunk,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

              if (options.preload !== false) {
                preload(root);
              }

              cid$1 = cid.CID.asCID(root);

              if (cid$1) {
                _context2.next = 5;
                break;
              }

              throw new Error("Unexpected error converting CID type: ".concat(root));

            case 5:
              log("Exporting ".concat(cid$1, " as car"));
              _context2.next = 8;
              return _awaitAsyncGenerator(writer.CarWriter.create([cid$1]));

            case 8:
              _yield$_awaitAsyncGen = _context2.sent;
              writer$1 = _yield$_awaitAsyncGen.writer;
              out = _yield$_awaitAsyncGen.out;
              err = null;

              _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return traverseWrite(repo, {
                          signal: options.signal,
                          timeout: options.timeout
                        }, cid$1, writer$1, codecs);

                      case 3:
                        writer$1.close();
                        _context.next = 9;
                        break;

                      case 6:
                        _context.prev = 6;
                        _context.t0 = _context["catch"](0);
                        err = _context.t0;

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[0, 6]]);
              }))();

              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context2.prev = 15;
              _iterator = _asyncIterator(out);

            case 17:
              _context2.next = 19;
              return _awaitAsyncGenerator(_iterator.next());

            case 19:
              if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                _context2.next = 28;
                break;
              }

              chunk = _step.value;

              if (!err) {
                _context2.next = 23;
                break;
              }

              return _context2.abrupt("break", 28);

            case 23:
              _context2.next = 25;
              return chunk;

            case 25:
              _iteratorAbruptCompletion = false;
              _context2.next = 17;
              break;

            case 28:
              _context2.next = 34;
              break;

            case 30:
              _context2.prev = 30;
              _context2.t0 = _context2["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 34:
              _context2.prev = 34;
              _context2.prev = 35;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context2.next = 39;
                break;
              }

              _context2.next = 39;
              return _awaitAsyncGenerator(_iterator.return());

            case 39:
              _context2.prev = 39;

              if (!_didIteratorError) {
                _context2.next = 42;
                break;
              }

              throw _iteratorError;

            case 42:
              return _context2.finish(39);

            case 43:
              return _context2.finish(34);

            case 44:
              if (!err) {
                _context2.next = 46;
                break;
              }

              throw err;

            case 46:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[15, 30, 34, 44], [35,, 39, 43]]);
    }));
    return _dagExport.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(dagExport);
}

function traverseWrite(_x2, _x3, _x4, _x5, _x6) {
  return _traverseWrite.apply(this, arguments);
}

function _traverseWrite() {
  _traverseWrite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(repo, options, cid, writer, codecs) {
    var seen,
        b58Cid,
        block,
        _iterator2,
        _step2,
        link,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            seen = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : new Set();
            b58Cid = cid.toString(base58.base58btc);

            if (!seen.has(b58Cid)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return");

          case 4:
            _context3.next = 6;
            return getBlock(repo, options, cid, codecs);

          case 6:
            block = _context3.sent;
            log("Adding block ".concat(cid, " to car"));
            _context3.next = 10;
            return writer.put(block);

          case 10:
            seen.add(b58Cid);
            _iterator2 = _createForOfIteratorHelper(block.links);
            _context3.prev = 12;

            _iterator2.s();

          case 14:
            if ((_step2 = _iterator2.n()).done) {
              _context3.next = 20;
              break;
            }

            link = _step2.value;
            _context3.next = 18;
            return traverseWrite(repo, options, link, writer, codecs, seen);

          case 18:
            _context3.next = 14;
            break;

          case 20:
            _context3.next = 25;
            break;

          case 22:
            _context3.prev = 22;
            _context3.t0 = _context3["catch"](12);

            _iterator2.e(_context3.t0);

          case 25:
            _context3.prev = 25;

            _iterator2.f();

            return _context3.finish(25);

          case 28:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[12, 22, 25, 28]]);
  }));
  return _traverseWrite.apply(this, arguments);
}

function getBlock(_x7, _x8, _x9, _x10) {
  return _getBlock.apply(this, arguments);
}

function _getBlock() {
  _getBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(repo, options, cid, codecs) {
    var bytes, links, codec, block$1;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return repo.blocks.get(cid, options);

          case 2:
            bytes = _context4.sent;
            links = [];
            _context4.next = 6;
            return codecs.getCodec(cid.code);

          case 6:
            codec = _context4.sent;

            if (!codec) {
              _context4.next = 12;
              break;
            }

            block$1 = block.createUnsafe({
              bytes: bytes,
              cid: cid,
              codec: codec
            });
            links = _toConsumableArray(block$1.links()).map(function (l) {
              return l[1];
            });
            _context4.next = 14;
            break;

          case 12:
            if (NO_LINKS_CODECS.includes(cid.code)) {
              _context4.next = 14;
              break;
            }

            throw new Error("Can't decode links in block with codec 0x".concat(cid.code.toString(16), " to form complete DAG"));

          case 14:
            return _context4.abrupt("return", {
              cid: cid,
              bytes: bytes,
              links: links
            });

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getBlock.apply(this, arguments);
}

exports.createExport = createExport;